import { render, staticRenderFns } from "./ListRegist.vue?vue&type=template&id=5ca58440"
import script from "./ListRegist.vue?vue&type=script&lang=js"
export * from "./ListRegist.vue?vue&type=script&lang=js"
import style0 from "./ListRegist.vue?vue&type=style&index=0&id=5ca58440&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports